import { CollapsibleFilter } from "../../ui/filter/CollapsibleFilter";
import DateFilter from "../../ui/filter/DateFilter";
import { cn } from "@/lib/utils";
import { dueDateFilters, postedDateFilters } from "./FilterValues";
import SearchFilter from "../../ui/filter/SearchFilter";

export const sbirAgency = [
  { label: "Department of Defense", keys: ["DOD"] },
  { label: "Department of Homeland Security", keys: ["DHS"] },
  { label: "Department of Health and Human Services", keys: ["HHS"] },
];

const branch = [
  "CBD",
  "SDA",
  "S&T",
  "SCO",
  "NAVY",
  "NIH",
  "USAF",
  "DMEA",
  "DOD",
  "DHA",
  "DLA",
  "MDA",
  "OSD",
  "ARMY",
  "SOCOM",
  "DARPA",
  "HHS",
];

const phase = ["Phase I", "Phase II", "BOTH"];
const program = ["SBIR", "STTR", "BOTH"];

export default function SbirFilters({ className, ...props }) {
  return (
    <div className={cn("flex flex-col space-y-4", className)} {...props}>
      <DateFilter
        title={"Close Date"}
        filters={dueDateFilters}
        urlName="closeDateUnix"
      />
      <DateFilter
        title={"Release Date"}
        filters={postedDateFilters}
        urlName="releaseDateUnix"
      />
      <CollapsibleFilter title="Program" urlName="program" items={program} />
      <CollapsibleFilter title="Phase" urlName="phase" items={phase} />
      <CollapsibleFilter title="Agency" urlName="agency" items={sbirAgency} />

      <SearchFilter
        title={"Branch"}
        urlName="branch"
        placeholder="Ex: DARPA"
        items={branch}
      />
    </div>
  );
}
